import React, { useEffect, useState, useContext } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { serverContext, fetchFromServer } from '../App';
import { TabPanel } from './TabPanel';
import ReactJson from 'react-json-view';

const styles = {
    jsonView: {
        fontSize: '12px',
        lineHeight: '90%',
    },
};

function decodeBase64AndParseJSON(encodedString) {
    const parts = encodedString.split('.');
    if (parts.length !== 3) {
        throw new Error('Provided string is not JWT.');
    }

    const encodedJSON = parts[1];

    // Check if the middle part is base64 encoded
    const isBase64Encoded = /^[a-zA-Z0-9-_]+={0,2}$/.test(encodedJSON);
    if (!isBase64Encoded) {
        throw new Error('The payload section of the license is not base64 encoded.');
    }

    try {
        // Decode the base64 encoded JSON to string
        const decodedString = atob(encodedJSON);

        // Parse the decoded JSON string to JavaScript object
        const parsedJSON = JSON.parse(decodedString);

        return parsedJSON;
    } catch (error) {
        console.error('Error decoding or parsing JSON:', error);
        return null;
    }
}





export default function ShowLicenseDlg(props) {

    const theme = useTheme();
    const { onCancel, onAlert } = props;
    const { server } = useContext(serverContext);
    const [tabValue, setTabValue] = React.useState(0);
    const [decodedLicense, setDecodedLicense] = useState();
    const [licenseFile, setLicenseFile] = useState('');
    const [token, setToken] = useState('');

    useEffect(() => {

        const loadLicense = async () => {
            try {
                const res = await fetchFromServer('licenseFile', server);
                if (res.data) {
                    const { file, token } = res.data;
                    setLicenseFile(file);
                    setToken(token);

                    if (token) {
                        try {
                            const lic = decodeBase64AndParseJSON(token);
                            setDecodedLicense(lic);
                            onAlert?.('Token decoded.', 'success');
                        } catch (error) {
                            onAlert?.(`Cannot decode token. ${error.message}`, 'error');
                        }
                    }
                }

            } catch (error) {
                setLicenseFile('')
                setToken('');
            }
        }

        loadLicense();

    }, [server, onAlert]);


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // Choose ReactJson theme based on Material-UI theme.
    // Support both MUI v5 (`palette.mode`) and MUI v4 (`palette.type`).
    const palette = theme && theme.palette ? theme.palette : {};
    const paletteMode = palette.mode || palette.type || '';
    const isDark = String(paletteMode).toLowerCase() === 'dark';
    const reactJsonTheme = isDark ? 'monokai' : 'rjv-default';

    return (
        <Dialog open={true} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                }}
            >
                <Box sx={{ padding: 2, width: '90%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '400px', overflow: 'auto' }}>
                        <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="License" />
                            <Tab label="Token" />
                        </Tabs>
                    </Box>
                    <div style={{ padding: '12px' }}>
                        <TabPanel value={tabValue} index={0}  >
                            <Typography variant="caption" display="block" gutterBottom >
                                License file: {licenseFile}
                            </Typography>
                            <ReactJson
                                displayObjectSize={false}
                                displayDataTypes={false}
                                name={false}
                                theme={reactJsonTheme}
                                style={styles.jsonView}
                                enableClipboard={false}
                                quotesOnKeys={false}
                                src={decodedLicense || {}}
                            />
                        </TabPanel>
                        <TabPanel value={tabValue} index={1}>
                            <Box sx={{ width: '100%', marginLeft: '8px', marginRight: '8px' }}>
                                <Typography variant="caption" gutterBottom>Token</Typography>
                                <Box
                                    component="div"
                                    sx={{
                                        width: '100%',
                                        fontFamily: 'monospace',
                                        fontSize: '11px',
                                        lineHeight: 1.15,
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-all',
                                        padding: '6px',
                                        maxHeight: '360px',
                                        overflow: 'auto',
                                        color: theme.palette.text.primary,
                                        borderRadius: 1,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        backgroundColor: 'transparent'
                                    }}
                                >
                                    {token}
                                </Box>
                            </Box>
                        </TabPanel>
                    </div>
                    <Box justifyContent="flex-end" spacing={4} sx={{ mt: 2, mb: 2 }}>
                        <Button size="small" variant="contained" color="primary" onClick={() => onCancel?.()}>
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
};
